<template>
  <transition name="fade" mode="out-in">
    <!-- <router-view/> -->
    <router-view v-if="isRouterAlive"></router-view>
  </transition>
</template>
<script>
export default {
  name: 'App',
  provide(){
    return {
      reload:this.reload
    }
  },
  data () {
    return {
      isRouterAlive:true,
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(()=>{
        this.isRouterAlive = true
      })
    }
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      const meta = document.createElement('meta')
      meta.name = 'referrer';
      meta.content = 'no-referrer'
      document.head.appendChild(meta)
    }
  }
}
</script>
<style lang="less">
// 页面载入动画
.fade-enter {
  opacity:0;
}
.fade-leave{
  opacity:1;
}
.fade-enter-active{
  transition:opacity .1s;
}
.fade-leave-active{
  opacity:0;
  transition:opacity .1s;
}
</style>



// WEBPACK FOOTER //
// src/App.vue